import { Box, Divider, Text } from "@wix/design-system";
import React, { useContext } from "react";
import { RicosContext } from "./../../../../../ricos-context";
import { PREDEFINED_SWATCH_COLORS } from "./../../../../../plugin-button/defaults";
import { removeColorDuplicates } from "./../../../../color-picker/new-color-picker/components/swatch-color-picker/utils";
import { CUSTOM_SWATCHES, PREDEFINED_SWATCHES, THEME_SWATCHES } from "../../data-hooks";
import { NewColorSwatches } from "../new-color-swatches";
import classes from "./swatch-color-picker-scss";
const SwatchColorPicker = ({
  currentColor,
  themeColors: themeColorsProp,
  customColors: customColorsProp,
  onAddClick,
  onColorSelected,
  onColorPreviewStart,
  onColorPreviewEnd,
  setAddButtonRef
}) => {
  const { t } = useContext(RicosContext);
  const { themeColors, customColors } = removeColorDuplicates(themeColorsProp, customColorsProp);
  return /* @__PURE__ */ React.createElement("div", { className: classes.content }, themeColors.length > 0 && /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(Box, { direction: "vertical", padding: "SP3", gap: "SP3" }, /* @__PURE__ */ React.createElement(Text, { size: "small", weight: "bold" }, t("Color_Picker_ThemeColor_Title")), /* @__PURE__ */ React.createElement(
    NewColorSwatches,
    {
      colors: themeColors,
      selectedColor: currentColor?.toUpperCase(),
      onColorSelected,
      onColorPreviewStart,
      onColorPreviewEnd,
      dataHook: THEME_SWATCHES
    }
  )), /* @__PURE__ */ React.createElement(Divider, null)), /* @__PURE__ */ React.createElement(Box, { direction: "vertical", padding: "SP3", gap: "SP3" }, /* @__PURE__ */ React.createElement(Text, { size: "small", weight: "bold" }, t("Color_Picker_CustomColor_Title")), /* @__PURE__ */ React.createElement(Box, { direction: "vertical", gap: "SP2" }, /* @__PURE__ */ React.createElement(
    NewColorSwatches,
    {
      colors: PREDEFINED_SWATCH_COLORS,
      selectedColor: currentColor?.toUpperCase(),
      onColorSelected,
      onColorPreviewStart,
      onColorPreviewEnd,
      dataHook: PREDEFINED_SWATCHES
    }
  ), /* @__PURE__ */ React.createElement(
    NewColorSwatches,
    {
      colors: customColors,
      onAddClick,
      setAddButtonRef,
      selectedColor: currentColor?.toUpperCase(),
      onColorSelected,
      onColorPreviewStart,
      onColorPreviewEnd,
      dataHook: CUSTOM_SWATCHES
    }
  ))));
};
export {
  SwatchColorPicker
};
//# sourceMappingURL=swatch-color-picker.js.map
